import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure35 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 40,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height:'1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
        }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [ 
		     "Malawi 2020",
		     "Myanmar 2015",
		     "Zimbabwe 2019",
		     "Cambodge 2019",
		     "Rwanda 2019",
		     "Burundi 2016",
		     "Papouasie-Nouvelle-Guinée 2018",
		     "Éthiopie 2019",
		     "Albanie 2017",
		     "Indonésie 2017",
		     "Arménie 2015",
		     "République-Unie de Tanzanie 2019",
		     "Zambie 2018",
		     "Lesotho 2014",
		     "Libéria 2020",
		     "Népal 2016",
		     "Ghana 2017",
		     "Ouganda 2019",
		     "Tchad 2014",
		     "Guatemala 2018",
		     "Afghanistan 2015",
		     "Haïti 2016",
		     "Inde 2015",
		     "Sierra Leone 2018",
		     "Cameroun 2018",
		     "Nigéria 2019",
		     "Pérou 2019",
		     "Guinée-Bissau 2019",
		     "Togo 2019",
		     "Sénégal",
		     "Burkina Faso 2019",
		     "Côte d’Ivoire 2019",
		     "Bénin 2019",
		     "Niger 2019",
		     "Mali 2019",
		     "Pakistan 2017",
               ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: [{ // Primary yAxis
        labels: {
          
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 100,
        min: 0,
        tickInterval: 10,
        format: '{value.percentage}%',
        gridLineWidth: 0,
        floor: 0,
        title: {
          text: "%",
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        //headerFormat: '<div>{point.key}</div>',
        valueSuffix: '%',
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [
        {
            name: 'Hommes',
            color: '#ed7d31',
            data: [ 42.2, 43.1, 43.6, 46, 46.4, 47.2, 48.3, 49.6, 50.3, 50.5, 50.6, 52.1, 54.4, 54.5, 57.9, 58.3, 61.3, 61.3, 61.6, 62.8, 63.3, 63.9, 64.3, 65.4, 67.3, 68.4, 70.6, 75.7, 77.3, 80.7, 82.5, 83.8, 85.1, 85.3, 91.4, 93.4 ]
        },
        {
            name: 'Femmes',
            color: '#5b9bd5',
            data: [ 57.8, 56.9, 56.4, 54, 53.6, 52.8, 51.7, 50.4, 49.7, 49.5, 49.4, 47.9, 45.6, 45.5, 42.1, 41.7, 38.7, 38.7, 38.4, 37.2, 36.7, 36.1, 35.7, 34.6, 32.7, 31.6, 29.4, 24.3, 22.7, 19.3, 17.5, 16.2, 14.9, 14.7, 8.6, 6.6 ]
        },
      ]
}
